var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-box"},[_c('p',{staticClass:"line",class:{
      left:_vm.newPosition === 'left',
      center:_vm.newPosition === 'center',
      right:_vm.newPosition === 'right',
    }},[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.$attrs.name))])])])}
var staticRenderFns = []

export { render, staticRenderFns }